<template>
  <div class="processed-text-container">
    <p
      class="processed-text"
      v-html="preparedContent"
      style="overflow-wrap: break-word"
    ></p>
    <p v-bind:style="{color: readMoreColor}" class="read-more" v-if="textIsShortened && readMore">Read more</p>
  </div>
</template>


<script>
import { autoLink } from "vue-highlights";

export default {
  name: "ProcessedPostText",
  props: {
    content: {
      type: String,
    },
    OGLinkToRemove: {
      type: String,
    },
    readMore: {
      type: Boolean,
      default: true,
    },
    readMoreColor: {
      type: String,
      default: "#57aaf6"
    }
  },
  data() {
    return {
      TEXT_MAX_SIZE: 100,
      textIsShortened: false,
    };
  },
  watch:{
    getTextIsShortened(){
      return this.textIsShortened;
    }
  },
  computed: {
    showReadMore() {
      if (this.content.length > this.TEXT_MAX_SIZE) return true;
      else return false;
    },
    preparedContent() {
      var content = this.content;
      if (this.OGLinkToRemove)
        // If a link is provided to be removed this remove it to cover the case of OG-Tags
        content = content.replace(this.OGLinkToRemove, "");
      
      if (this.readMore) content = this.addReadMoreFeature(content)
      
      return autoLink(content,{
        extractUrlsWithoutProtocol: true, // Defaults to true
        usernameClass: "username-highlight",
        hashtagClass: "hashtag-highlight",
        urlClass: "url-highlight",
      });
    },
  },
  methods: {
    addReadMoreFeature(text) {
      if (text.length > this.TEXT_MAX_SIZE) {
        this.textIsShortened = true;
        return text.substring(0, this.TEXT_MAX_SIZE) + "...";
      } else return text;
    },
  },
};
</script>

<style >
/* We dont use scoped style because these styles related for html components appended after rendering the Vue app !!*/
.url-highlight {
  color: #57aaf6 !important;
  text-decoration: none;
  pointer-events: none;
}

.hashtag-highlight{
  text-decoration: none;
  color: white;
  background-color: #57aaf6;
  border-radius: 1rem;
  margin: 0 0.2rem 0 0.2rem;
   padding: 0 0.2rem 0 0.2rem;
}


.username-highlight {
  text-decoration: none;
  color: inherit; /* blue colors for links too */
}

/* Disable links for hashtags and mentions  */
.username-highlight,
.hashtag-highlight {
  pointer-events: none;
  cursor: default;
}
</style>

<style scoped>
p {
  padding: 0;
  margin: 0;
}
.processed-text {
  display: inline;
  padding: 0;
  margin: 0;
}
.read-more {
  display: inline;
}
.processed-text-container {
  display: inline;
  padding: 0;
  margin: 0;
}
</style>

